//ページ内アンカー用js
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
  
      const targetSection = document.querySelector(this.getAttribute('href'));
      if (targetSection) {
        const headerHeight = document.querySelector('header').offsetHeight;
        const targetOffset = targetSection.offsetTop - headerHeight;
  
        window.scrollTo({
          top: targetOffset,
          behavior: 'smooth'
        });
      }
    });
  });

//ヘッダーの色変更用js
  window.addEventListener('scroll', function () {
    const header = document.querySelector('header');
    const targetSection = document.querySelector('.--about'); // 要素が見えたときに色を変えたいセクション
    const targetSectionRemove = document.querySelector('#hero'); // 要素が見えたときに色を変えたいセクション
 
    if (isElementInViewport(targetSection)) {
      header.classList.add('is-active') // 要素が画面内に入ったら背景色を変更
    }
    if (isElementInViewport(targetSectionRemove)) {
      header.classList.remove('is-active') // 要素が画面内に入ったら背景色を変更
    }
  });

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }